<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Edit User Information</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          Error occurred
        </div>

        <app-mat-text-input formControlName="username" label="Username"
                            [disabled]="(!isEditorAdmin && editModel.roleId == adminRoleId)"
                            name="username" [submitted]="submitted"
                            (focusout)="updateEmailField()"></app-mat-text-input>
        <app-mat-text-input [formControl]="getFormControl('firstName')" label="First Name"
                            name="firstName" [submitted]="submitted"></app-mat-text-input>
        <app-mat-text-input [formControl]="getFormControl('lastName')" label="Last Name"
                            name="lastName" [submitted]="submitted"></app-mat-text-input>
        <app-mat-text-input formControlName="email" label="Email" name="email"
                            [submitted]="submitted"></app-mat-text-input>
        <app-mat-phone-number-input [formControl]="getFormControl('phoneNumber')" label="Phone Number"
                                    name="phoneNumber" [submitted]="submitted"></app-mat-phone-number-input>
        <app-mat-number-input [formControl]="getFormControl('extension')" label="Extension" name="extension"
                              [submitted]="submitted"></app-mat-number-input>
        <app-mat-simple-select [formControl]="getFormControl('roleId')" label="Role" name="role"
                               [disabled]="(!isEditorAdmin && editModel.roleId == adminRoleId)"
                               [selectItems]="roles" [disabledItems]="disabledRoles"
                               [submitted]="submitted"></app-mat-simple-select>
        <!--<app-mat-checkbox-input [formControl]="getFormControl('approved')" label="Enabled" name="approved"
                                [disabled]="(!isEditorAdmin && editModel.roleId == adminRoleId)"
                                [submitted]="submitted"></app-mat-checkbox-input>-->
      </mat-card-content>
    </mat-card>
  </form>
</div>

<div class="main-container" *ngIf="hasBasicSoftPhoneModule && hasProMessagingModule">
  <mat-card appearance="outlined">
    <mat-card-title>Send Login Info for the TeleGo Mobile App</mat-card-title>
    <mat-card-content>
      <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="hasBasicSoftPhoneError">
        Unable to send login information. Please try again later.
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button type="button" color="primary" matTooltip="Send" (click)="onBasicSoftPhoneSubmit()"
              [promiseBtn]="sendQrCodePromise">Send
      </button>
    </mat-card-actions>
  </mat-card>

  <form [formGroup]="basicSoftPhoneSettingForm" novalidate (ngSubmit)="onBasicSoftPhoneSettingsSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Edit TeleGo Mobile App Settings</mat-card-title>
      <mat-card-content>
        <app-mat-simple-select formControlName="smsNumberId"
                               name="smsNumberId"
                               label="Phone Number For Text Messages"
                               [selectItems]="smsPhoneNumbers"
                               [submitted]="submitted"></app-mat-simple-select>
      </mat-card-content>
      <mat-card-actions>
        <button type="submit" mat-raised-button color="primary" matTooltip="Save changes"
                [promiseBtn]="buttonBasicSoftPhoneSettingsSubmitPromise">
          Save
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>

<div class="main-container" *ngIf="hasSoftPhoneModule">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Edit TeleGo Desktop App Settings</mat-card-title>
      <mat-card-content>
        <app-mat-checkbox-input [formControl]="getFormControl('enableCounterPath')"
                                label="Enable Desktop App" name="enableCounterPath"
                                [submitted]="submitted"></app-mat-checkbox-input>
        <app-mat-checkbox-input *ngIf="editModel.enableCounterPath"
                                [formControl]="getFormControl('resetSoftPhonePassword')"
                                label="Generate New Password" name="resetSoftPhonePassword"
                                [submitted]="submitted"></app-mat-checkbox-input>
      </mat-card-content>
    </mat-card>
  </form>
</div>
<div class="has-edit-action-bar">&nbsp;</div>
<div class="edit-action-bar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <button mat-raised-button type="button" color="primary" matTooltip="Save changes"
          (click)="onSubmit()" [disabled]="submitted" [promiseBtn]="buttonSubmitPromise"
          *ngIf="hasEditAccess">Save
  </button>
  <button type="button" matTooltip="Resend Invitation"
          mat-raised-button
          (click)="onResendClick()"
          *ngIf="hasEditAccess && editModel.id && editModel.id !== 'new'">Resend Invitation
  </button>
  <button mat-raised-button class="only-icon" color="warn" type="button" matTooltip="Remove user from company"
          *ngIf="hasDeleteAccess && editModel.id && editModel.id !== 'new' && (isEditorAdmin || editModel.roleId != adminRoleId)"
          (click)="onDeleteClick()">
    <mat-icon>delete</mat-icon>
  </button>

  <app-mat-checkbox-input [formControl]="getFormControl('approved')" label="Enabled" name="approved"
                          [disabled]="(!isEditorAdmin && editModel.roleId == adminRoleId)"
                          [submitted]="submitted"></app-mat-checkbox-input>
</div>
